import { Injectable } from '@angular/core';
import { AsyncValidator, ValidationErrors, FormControl } from '@angular/forms';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserService } from 'src/core/services/administration/user.service';

@Injectable({ providedIn: 'root' })
export class UserExternalIdValidator implements AsyncValidator {
  userId: string | null;

  constructor(private userService: UserService) {}

  validate(
    formControl: FormControl
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    const id = this.userId == null ? '' : this.userId;
    const externalId = formControl.value;
    if (externalId == null || externalId == '') {
      return of(null);
    }
    return this.userService.getByExternalId(externalId, id).pipe(
      map(
        response => {
          return response !== null && response === true ? { externalIdInUse: true } : null;
        },
        catchError(() => {
          return null;
        })
      )
    );
  }
}
